import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

const Mediation = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Mediation</Text>
      <Text style={styles.list}>
        Buyer and Seller will submit all disputes or claims that arise from this
        Agreement, including disputes and claims over deposit monies, to
        mediation. Mediation will be conducted in accordance with the Rules and
        Procedures of the Home Sellers/Home Buyers Dispute Resolution System,
        unless it is not available, in which case Buyer and Seller will mediate
        according to the terms of the mediation system offered or endorsed by
        the local Association of Realtors™. Mediation fees, contained in the
        mediator’s fee schedule, will be divided equally among the parties and
        will be paid before the mediation conference. Legal proceedings may be
        initiated prior to the completion of the mediation process to stop any
        statute of limitations from expiring and for the purpose of indexing a
        lis pendens by Buyer to prevent the transfer of title to a third party
        when Buyer is seeking to purchase the Property. The parties agree that
        all proceedings shall be stayed until the completion of mediation and
        that a court of competent jurisdiction may award attorneys' fees to the
        prevailing party should the court find that a party has unreasonably
        breached this provision or acted in bad faith. Any agreement reached
        through mediation and signed by the parties will be binding. Any
        agreement to mediate disputes or claims arising from this Agreement will
        survive settlement
      </Text>
    </View>
  );
};

export default Mediation;
